// Add your JS customizations here
jQuery(document).ready(function($) {
	// Initiate WOW Animations
	new WOW().init();


	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});

	// On CTA click
	$('#cta-popup a').on('click', function() {
		setCookie('ctaPopupDismissed', 'true');
	});


	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Extra scroll amount
		var extraHeight = 20;

		// Total trigger point
		var scrollTrigger = navHeight + extraHeight;

		if ($(document).scrollTop() > scrollTrigger) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	scrollbarState();

	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// Menu - Hamburger
	$('.hamburger-wrap').click(function () {
		if ($('body').hasClass('menu-open')) {
			$('.hamburger').removeClass('is-active');

			$('body').removeClass('menu-open parent-menu-open');
			$('#parent-menu').removeClass('open');
			$('.menu-block, .sub-menu, .child-menu').removeClass('open');
			$('.hasSub a, .hasChild a').removeClass('active');

		} else {
			$('.hamburger').addClass('is-active');

			$('body').addClass('menu-open parent-menu-open');
			$('#parent-menu').addClass('open');
		}
	});

	// No Parent Triggers
	$('.noParent a').click(function () {
		$('body').removeClass('parent-menu-open');
	});

	// Main Menu - Desktop
	$('#header-menu-left .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		// Toggle close
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('open');

			if (!$('.menu-block.open').length) {
				$('body').removeClass('menu-open');
				$('.hamburger').removeClass('is-active');
			}

			return;
		}

		$('.hamburger').addClass('is-active');

		$('#header-menu-left .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});

	$('#header-menu-right .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		// Toggle close
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('open');

			if (!$('.menu-block.open').length) {
				$('body').removeClass('menu-open');
				$('.hamburger').removeClass('is-active');
			}

			return;
		}

		$('.hamburger').addClass('is-active');

		$('#header-menu-right .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});

	$('#desktop-menu .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		// Toggle close
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('open');

			$('.child-menu-column .menu-block').removeClass('open');
			$('#desktop-menu .hasChild a').removeClass('active');

			return;
		}

		$('#desktop-menu .hasSub a').removeClass('active');
		$('.sub-menu-column .menu-block, .child-menu-column .menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');
	});

	$('#desktop-menu .hasChild a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		// Toggle close
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('open');
			return;
		}

		$('#desktop-menu .hasChild a').removeClass('active');
		$('.child-menu-column .menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');
	});

	// Main Menu - Mobile
	$('#mobile-menu .hasSub > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});

	$('#mobile-menu .hasChild > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});

	// Menu Toggle
	if ($('.main-nav-toggle').length > 0) {
		$('.main-nav-toggle').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');
			var assocLink = $(this).data('link');

			$('.hamburger').addClass('is-active');
			$('body').addClass('menu-open');

			$('#header-menu-left .hasSub a').removeClass('active');
			$('#header-menu-right .hasSub a').removeClass('active');
			$('.menu-block').removeClass('open');

			$(target).addClass('open');
			$(assocLink).addClass('active');
		});
	}


	// Menu Toggle
	if ($('.main-nav-toggle').length > 0) {
		$('.main-nav-toggle').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');
			var assocLink = $(this).data('link');

			// console.log(assocLink);

			$('.hamburger').addClass('is-active');
			$('body').addClass('menu-open');

			$('#header-menu-left .hasSub a').removeClass('active');
			$('#header-menu-right .hasSub a').removeClass('active');
			$('.menu-block').removeClass('open');
			$(target).addClass('open');
			$(assocLink).addClass('active');
		});
	}




	// Main Menu — scroll and menu active state
	function checkScroll() {
		var threshold = $(window).width() <= 992 ? 200 : 200;

		var scrolled = $(window).scrollTop() > threshold;

		var subActive = $('.isSubMenu.active').length > 0;
		var childActive = $('.isChildMenu.active').length > 0;

		if (scrolled || subActive || childActive) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}
	}

	function lockScroll() {
		$('body').addClass('no-scroll');
	}

	function unlockScroll() {
		$('body').removeClass('no-scroll');
	}

	// Initial check
	checkScroll();

	// Re-run on scroll, resize
	$(window).on('scroll resize', checkScroll);

	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});




	// Sliders
	$('.accreditation-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 20000,
		cssEase: 'linear',
		pauseOnHover: false,
		pauseOnFocus: false,
		centerMode: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});


	const $slider = $('.footer-accreditation-slider');
	const slideCount = $slider.children().length;
	// Base values
	const baseSlides = 3;
	const baseSpeed = 3000;

	// Scale the duration with the number of slides
	const speed = Math.max(baseSpeed, baseSpeed * (slideCount / baseSlides));

	$slider.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: speed,
		cssEase: 'linear',
		arrows: false,
		dots: false,
		infinite: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		swipe: false,
		draggable: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.your-smile-before-afters-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.your-smile-arrow-left'),
		nextArrow: $('.your-smile-arrow-right'),
	});

	$('.treatment-before-afters-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.treatment-before-after-arrow-left'),
		nextArrow: $('.treatment-before-after-arrow-right'),
	});

	$('.treatment-videos-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		prevArrow: $('.treatment-videos-arrow-left'),
		nextArrow: $('.treatment-videos-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.treatment-related-concerns-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.treatment-related-concerns-arrow-left'),
		nextArrow: $('.treatment-related-concerns-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.treatment-related-treatments-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.treatment-related-treatments-arrow-left'),
		nextArrow: $('.treatment-related-treatments-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.treatment-testimonials-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.treatment-testimonials-arrow-left'),
		nextArrow: $('.treatment-testimonials-arrow-right'),
	});

	$('.concern-related-treatments-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.concern-related-treatments-arrow-left'),
		nextArrow: $('.concern-related-treatments-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	// Smile Gallery Slider
	$('.before-after-gallery-slider').each(function () {

		let $slider = $(this);

		let $wrap = $slider.closest('.before-after-gallery-wrap');

		let $prevArrow = $wrap.find('[class*="arrow-left"]');
		let $nextArrow = $wrap.find('[class*="arrow-right"]');

		if ($slider.find('.slide-wrap').length > 1) {

			$slider.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				infinite: true,
				adaptiveHeight: true,
				autoplay: true,
				autoplaySpeed: 3000,
				pauseOnHover: false,
				pauseOnFocus: false,
				prevArrow: $prevArrow,
				nextArrow: $nextArrow,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});

		}

	});

	$('.team-members-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		pauseOnFocus: false,
		prevArrow: $('.related-team-arrow-left'),
		nextArrow: $('.related-team-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.treatment-steps-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		infinite: true,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: true,
		prevArrow: $('.stages-of-treatments-arrow-left'),
		nextArrow: $('.stages-of-treatments-arrow-right'),
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});


	// Smile Gallery
	$('.zoom-icon').on('click', function () {

		const beforeImage = $(this).data('before');
		const afterImage = $(this).data('after');
		const title = $(this).data('title');
		const modalContent = `

			<div class="container-fluid h-100">
				<div class="row h-100 align-items-center justify-content-center">
					<div class="col-lg-4">
						<div class="text-center pb-30">

							<button class="before-after-modal-close d-inline-flex align-items-center justify-content-center gap-2" type="button">
								<i class="fa-thin fa-x tc-white fs30"></i><span class="ibm-plex fs16 fw-medium ls100 text-uppercase tc-white">Close</span>
							</button>

						</div>

						<img src="${beforeImage}" class="img-fluid w-100">

						<img src="${afterImage}" class="img-fluid w-100">

					</div>
				</div>
			</div>

		`;

		$('.before-after-modal-content').html(modalContent);
		$('.before-after-modal-title').text(title);
		$('.before-after-modal').addClass('active');
		$('body').addClass('overflow-hidden');

	});

	$(document).on('click', '.before-after-modal-close, .before-after-modal-overlay', function () {
		$('.before-after-modal').removeClass('active');
		$('body').removeClass('overflow-hidden');
	});




	$('.archive-select2 select').select2({
		placeholder: 'Archive'
	});


	$('.concerns-filter-select2').select2({
		placeholder: 'Select Concern Category',
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$('.concerns-filter-select2').on('change', function () {
		window.location.href = $(this).val();
	});

	$('.aesthetics-filter-select2').select2({
		placeholder: 'Select Aesthetics Category',
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$('.aesthetics-filter-select2').on('change', function () {
		window.location.href = $(this).val();
	});

	$('.treatments-filter-select2').select2({
		placeholder: 'Select Treatment Category',
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$('.treatments-filter-select2').on('change', function () {
		window.location.href = $(this).val();
	});

	$('.patient-stories-filter-select2').select2({
		placeholder: 'Select Patient Category',
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$('.patient-stories-filter-select2').on('change', function () {
		window.location.href = $(this).val();
	});


	$('.smile-gallery-select2').select2({
		placeholder: 'Select Dental Category',
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$('.smile-gallery-select2').on('change', function () {
		window.location.href = $(this).val();
	});



	// Smooth Scroll
	$('.sticky-header a').on('click', function (e) {

		const target = $(this.hash);

		if (target.length) {

			e.preventDefault();

			$('html, body').animate({

				scrollTop: target.offset().top - 175

			}, 600);

		}

	});


	// Fixes the flashing image on Vimeo iFrames with player.js file
	jQuery(document).ready(function($) {
		$('.onload-iframe').each(function () {
			var $iframe = $(this);
			var player = new Vimeo.Player(this);

			player.on('play', function () {
				$iframe.addClass('video-ready');
			});
		});
	});


});
